import Text from './Text';

// export types
export type { TextProps } from './Text';

// export components
export { Text };
export default Text;
